import { render, staticRenderFns } from "./createFormaPagamento.vue?vue&type=template&id=05486dc2&scoped=true&"
import script from "./createFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./createFormaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./createFormaPagamento.vue?vue&type=style&index=0&id=05486dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05486dc2",
  null
  
)

export default component.exports